import React from "react";
import finalFormObj from "../../../Utils/finalFormObj";
import CustomForm from "../../Commons/CustomForm/CustomForm";
import { useState } from "react";
import { useMemo } from "react";
import CustomButton from "../../Commons/Button/CustomButton";
import style from "./NewPassGenerate.module.css";
import Loader from "../../Commons/Loader/Loader";
import BoxedInput from "../../Commons/CustomForm/BoxedInput";
import swal from "sweetalert";
import { apiFormatPostFullCtrl } from "../../../Api/ApiFormat";
import { PreventSqlInjection } from "../../../Utils/PreventSqlInjection";

function NewPassGenerate({ resetForm,close, uname }) {
  const [isLoading, setIsloading] = useState(false);

  const [OTP, setOTP] = useState("");
  const [isValidOTP, setisValidOTP] = useState(false);
  const [ShowErrOnBlur, setShowErrOnBlur] = useState(false);

  const [formData, setFormData] = useState([
    {
      type: "password",
      isValid: false,
      error: "",
      value: "",
      name: "pass",
      label: "Password",
      minLength: 8,
      shouldLength: 20,
      placeholder: "Enter your password",
      required: true,
    },
    {
      type: "password",
      isValid: false,
      error: "",
      value: "",
      name: "cPass",
      label: "Confirm Password",
      minLength: 8,
      shouldLength: 20,
      placeholder: "Please Confirm password",
      required: true,
    },
  ]);

  //form handling
  const [finalForm, setFinalForm] = useState("");
  const [formIsValid, setFormIsValid] = useState(false);

  useMemo(() => {
    for (let i = 0; i < formData.length; i++) {
      if (formData[i].isValid === false) {
        setFormIsValid(false);
        return;
      }
      setFormIsValid(true);
    }
  }, [formData]);

  useMemo(() => {
    setFinalForm(finalFormObj(formData));
  }, [formData]);

  const generateNewPass = async () => {
    setIsloading(true);

    const regX =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%&*])[A-Za-z\d$@$!%*#?&]{6,}$/;

    try {
      if (!regX.test(finalForm.pass)) {
        throw new Error(
          "Password must contain : At least 6 characters, At least 1 uppercase letter(A-Z), At least 1 lowercase letter(a-z), At least 1 symbol letter(), At least 1 numeric letter(0-9) !"
        );
      } else if (finalForm.pass !== finalForm.cPass) {
        throw new Error("Password And Confirm Password Must Be Same!");
      }

      if (PreventSqlInjection(finalForm.pass)) {
        throw new Error("UnAuthorized Access!");
      }
      if (PreventSqlInjection(finalForm.cPass)) {
        throw new Error("UnAuthorized Access!");
      }

      const reqModel = {
        UserId: 0,
        Password: finalForm.pass,
        OTP:OTP ,
        Username: uname,
      };

      const apiResp = await apiFormatPostFullCtrl(
        "api/greenUser/resetPassword",
        reqModel
      );

       if(apiResp){
        if(apiResp.data){
          if(apiResp.data.errorCode === "200"){
            swal("Success!", "Password Reset Successfully", "success");
            resetForm();
            close();
          }else{
            close();
           throw new Error(apiResp.data.msg??"Some Error Occurred in Process Of Generating Password!");
          }
        }else{
          close();
         throw new Error("Some Error Occurred in Process Of Generating Password!");
        }
       }else{
        close();
        throw new Error("Some Error Occurred in Process Of Generating Password!");
       }

    } catch (err) {
      swal("Oops!", err.message.toLowerCase(), "error");
    }
    setIsloading(false);
  };

  return (
    <div className="main_popup">
      {isLoading && <Loader />}
      <div className={`main_popup_card ${style.card}`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (formIsValid) {
              if (isValidOTP) {
                generateNewPass();
              } else {
                setShowErrOnBlur(true);
              }
            }
          }}
        >
          {formData.map((el, ind) => {
            return (
              <>
                <CustomForm data={el} setFormData={setFormData} ind={ind} />
              </>
            );
          })}

          <div className={style.tpin}>
            <BoxedInput
              value={OTP}
              setter={setOTP}
              label={"Enter Your OTP"}
              name={"OTP"}
              length={4}
              isValid={setisValidOTP}
              showErrOnBlur={ShowErrOnBlur}
              setShowErrOnBlur={setShowErrOnBlur}
            />
          </div>

          <div className={`${style.buttonWrapper}`}>
            <CustomButton
              txt={"Cancel"}
              OnClickFunc={() => {
                close();
              }}
              type="Cancel"
            />

            <CustomButton
              txt={"Submit"}
              
              type="Submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewPassGenerate;
